// eslint-disable-next-line import/prefer-default-export
export function checkSecurityPolicyWasUpdatedWithErrors(errors: { securityPolicy: string }): boolean {
  const errorsList = [
    errors.securityPolicy
  ].filter((error: string) => error !== '');

  return errorsList.length === 1;
}
